import React, { useState } from 'react';
import './Termspanel.css';

const Termspanel = () => {
  // Initial predefined content
  const [termsContent, setTermsContent] = useState({
    informationDisclaimer: 'Default Information Disclaimer ',
    accuracyOfInformation: 'Default Accuracy of Information ',
    externalLinks: 'Default External Links ',
    governingLaw: 'Default Governing Law ',
  });

  // Dynamic sections that can be added or removed
  const [sections, setSections] = useState([
    { title: '', description: '' },
  ]);

  // Handle change for predefined content
  const handleContentChange = (e) => {
    const { name, value } = e.target;
    setTermsContent((prevContent) => ({
      ...prevContent,
      [name]: value,
    }));
  };

  // Handle change for dynamic sections (add/edit)
  const handleSectionChange = (index, field, value) => {
    const updatedSections = [...sections];
    updatedSections[index][field] = value;
    setSections(updatedSections);
  };

  // Add new section
  const handleAddSection = () => {
    setSections([...sections, { title: '', description: '' }]);
  };

  // Remove section
  const handleRemoveSection = (index) => {
    const updatedSections = sections.filter((_, i) => i !== index);
    setSections(updatedSections);
  };

  // Submit the form (predefined + dynamic content)
  const handleSubmit = async () => {
    try {
      const response = await fetch('/api/admin/update-terms', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...termsContent, sections }),
      });

      if (response.ok) {
        alert('Terms and Conditions updated successfully!');
      } else {
        alert('Failed to update Terms and Conditions');
      }
    } catch (error) {
      alert('Error updating Terms and Conditions');
    }
  };

  return (
    <div className="admin-panel122">
      <h2>Update Terms and Conditions</h2>

      {/* Predefined sections */}
      <div className="form-group122">
        <label>Information Disclaimer</label>
        <textarea
          name="informationDisclaimer"
          value={termsContent.informationDisclaimer}
          onChange={handleContentChange}
          placeholder="Edit Information Disclaimer"
        />
      </div>

      <div className="form-group122">
        <label>Accuracy of Information</label>
        <textarea
          name="accuracyOfInformation"
          value={termsContent.accuracyOfInformation}
          onChange={handleContentChange}
          placeholder="Edit Accuracy of Information"
        />
      </div>

      <div className="form-group122">
        <label>External Links</label>
        <textarea
          name="externalLinks"
          value={termsContent.externalLinks}
          onChange={handleContentChange}
          placeholder="Edit External Links"
        />
      </div>

      <div className="form-group122">
        <label>Governing Law</label>
        <textarea
          name="governingLaw"
          value={termsContent.governingLaw}
          onChange={handleContentChange}
          placeholder="Edit Governing Law"
        />
      </div>

      {/* Dynamic sections (Add, Remove) */}
      {sections.map((section, index) => (
        <div key={index} className="section-form122">
          <div className="form-group122">
            <label>Title</label>
            <input
              type="text"
              value={section.title}
              onChange={(e) => handleSectionChange(index, 'title', e.target.value)}
              placeholder="Enter Section Title"
            />
          </div>

          <div className="form-group122">
            <label>Description</label>
            <textarea
              value={section.description}
              onChange={(e) => handleSectionChange(index, 'description', e.target.value)}
              placeholder="Enter Section Description"
            />
          </div>

          {/* Remove section button */}
          {sections.length > 1 && (
            <button
              type="button"
              className="remove-section-btn122"
              onClick={() => handleRemoveSection(index)}
            >
              Remove Section
            </button>
          )}
        </div>
      ))}

      {/* Button to add new section */}
      <button className="add-section-btn122" onClick={handleAddSection}>
        Add New Section
      </button>

      <button className="submit-btn122" onClick={handleSubmit}>
        Update Terms and Conditions
      </button>
    </div>
  );
};

export default Termspanel;
